<div  id="containerFoto" class="container">
    <img class="background-foto" src="../../../assets/images/Itinerari-esperienze/03_Serre/03_3_Girifalco-Scolacium/03_3_Scolacium_La-Basilica-normanna-nel-parco-di-Scolacium.jpg">
<div class="content">
    <h1>Serre</h1>
    <h3>Girifalco</h3>
</div>
</div>
<br>
<div class="breadcrumb">
    <p><a>Scopri la Calabria</a> > <a>Parchi e Riserve</a> > <a>Parco Regionale delle Serre</a> > <a class="active">Girifalco</a></p>
</div>
<br>
<div id="fixed-element" [ngClass]="[isFixed ? 'fixed': 'notFixed']">
    <app-sidenav></app-sidenav>
</div>
<div class="row schedaItinerario">
    <h2>Girifalco-Scolacium-Girifalco</h2>
</div>
<br>
<div class="row schedaItinerario">
    <div class="col-xl-6 col-12">
        <img class="itinerario-foto" src="../../../assets/images/Itinerari-esperienze/03_Serre/03_3_Girifalco-Scolacium/03_3_Scolacium_La-Basilica-normanna-nel-parco-di-Scolacium.jpg">
    </div>
    <div class="col-xl-4 ml-4 col-12">
        <div id="map" class="mapInfo"></div>
    </div>
</div>
<br>
<div class="row schedaItinerario">
    <div class="col-xl-6 col-12">
        <p class="testoItinerario">
            Si tratta di uno dei percorsi ad anello di 62,9 Km tra i più battuti dai cicloturisti che amano unire montagna e mare: 
            è quello che collega Girifalco al Golfo di Squillace. È uno splendido itinerario di viaggio che offre paesaggi davvero magnifici ed 
            anche esperienze di conoscenza fuori dall’ordinario.
            <br>
            <br>
            Da Girifalco il paese che sorge a nord dei monti delle preserre catanzaresi, proprio al centro dell’istmo, 
            in posizione dominante si parte per dirigersi verso le coste del Mar Jonio, nel Golfo di Squillace, 
            dove si trova Scolacium, Museo e Parco Archeologico nazionale, un sito di straordinaria importanza che si raggiunge incrociando paesi 
            di notevole interesse storico, che connotano anche la risalita verso Girifalco.
            Si parte da Amaroni al Km 6,2. La città del miele della Calabria (Millefiori, Acacia, Zagare, Castagno, Sulla ed Eucalipto), 
            si attraversa Vallefiorita e si raggiunge il centro di Squillace, paese di antica fondazione per la strategica posizione 
            che occupa sull’omonimo golfo. Qui si fa sosta per godere dello splendido centro storico del paese che ha una storia antica 
            inscritta nella strategica posizione che occupa sull’omonimo golfo. Impensabile non visitare il Castello di origine normanna, 
            la Concattedrale di Santa Maria Assunta e le botteghe dei ceramisti. Il viale Cassiodoro ricorda il politico e letterato romano 
            Flavio Magno Aurelio di Scolacium (490 ca. - 580 d.C.) che qui fondò il monastero con biblioteca e scriptorium che divenne il prototipo 
            dei centri culturali monastici del Medioevo. 
            <br>
            <br>
            Ripartiti da Squillace sulla SP172, si percorre una discesa adrenalinica che al Km 38,
             nel punto in cui i fiumi Alessi e Ghetterello confluiscono, incrocia il Santuario della Madonna del Ponte che nella chiesa custodisce 
             un venerato affresco della Madonna che allatta. 
            Approdati sulla costa jonica, alle porte di Roccelletta di Borgia si raggiunge il Museo e Parco archeologico nazionale di Scolacium. 
            Visitando questo sito di rara bellezza si scopre la storia di Skylletion, città della Magna Grecia che divenne una prospera colonia romana. 
            Si tratta di un nodo cruciale per le vie di comunicazione lungo la rotta dell’istmo calabrese, a presidio del Golfo di Squillace; 
            un ruolo strategico che Scolacium ha esercitato fino all’epoca normanna, come testimoniano i resti dell’imponente Basilica di Santa Maria della Roccella. 
            Per gli appassionati di musica jazz, nella vicina Roccella Jonica dal 1980 si tiene d’estate il Festival più longevo d’Italia. 
            Ripreso il viaggio in direzione di Girifalco sulla SP172 si raggiunge San Floro con il suo Museo della seta nel Castello Caracciolo. 
            Da qui si prosegue in direzione di Borgia cittadina ricostruita dopo il tragico terremoto del 1783, 
            con un centro storico gradevole e una campagna connotata da grandi estensioni di ulivi, per poi fare rientro a Girifalco.
        </p>
    </div>
    <div class="col-xl-4 ml-4 col-12">
        <div class="row">
            <div class="col">
                <h5>Percorso:</h5>
            </div>
            <div class="col right">
                <h5> in bici</h5>
            </div>
        </div>
        <div class="divider"></div>
        <div class="row">
            <div class="col">
                <h5>Difficoltà:</h5>
            </div>
            <div class="col right">
                <h5>difficile</h5>
            </div>
        </div>
        <div class="divider"></div>
        <div class="row">
            <div class="col">
                <h5>Lunghezza:</h5>
            </div>
            <div class="col right">
                <h5>62,9 Km</h5>
            </div>
        </div>
        <div class="divider"></div>
        <div class="row">
            <div class="col">
                <h5>Giorni:</h5>
            </div>
            <div class="col right">
                <h5>2</h5>
            </div>
        </div>
        <div class="divider"></div>
        <div class="row">
            <div class="col">
                <h5>Salita:</h5>
            </div>
            <div class="col right">
                <h5>1080 m</h5>
            </div>
        </div>
        <div class="divider"></div>
        <div class="row">
            <div class="col">
                <h5>Discesa:</h5>
            </div>
            <div class="col right">
                <h5>1090 m</h5>
            </div>
        </div>
        <div class="divider"></div>
        <div class="row">
            <div class="col">
                <h5>Luogo di Partenza:</h5>
            </div>
            <div class="col right">
                <h5>Girifalco</h5>
            </div>
        </div>
        <div class="divider"></div>
        <div class="row">
            <div class="col">
                <h5>Luogo di arrivo:</h5>
            </div>
            <div class="col right">
                <h5>Girifalco</h5>
            </div>
        </div>
        <div class="divider"></div>
    </div>
</div>
<br>
<br>
<div class="divider2">

</div>
<br>
<br>
<div class="row bannerPollino">
    <div class="col-10 col-xl-8">
        <h1 class="banner-header">ESPERIENZE E ITINERARI</h1>
        <br>
        <p>Scegli fra le tante idee di viaggio e proposte di itinerari tematici<br />per conoscere il Parco Regionale delle Serre.</p>
    </div>
    <div class="col-2 col-xl-1">
        <img style="width: 65%;" src="../../../assets/images/Logo-Parco-1024x1024.png">
    </div>
</div>
<br>
<br>
<div class="home-card">
    <div class="row">
        <div class="col-12 col-xl-3 one" id="one">
            <div class="card one">
                <div class="card-body">
                    <div class="content-card">
                        <h1>Sulle strade<br />della Ciclovia<br />dei Parchi</h1>
                        <a (click)="goToCiclovia()">Scopri</a>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-12 col-xl-3 two" id="two">
            <div class="card two">
                <div class="card-body">
                    <div class="content-card">
                        <h1>Serra San Bruno</h1>
                        <a (click)="goToLorica()">Scopri</a>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-12 col-xl-3 three" id="three">
            <div class="card three">
                <div class="card-body">
                    <div class="content-card">
                        <h1>Girifalco</h1>
                        <a (click)="goToArte()">Scopri</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<br>
<br>
<div class="divider2">
    
</div>
<br>
<br>
<app-mappe-tematiche></app-mappe-tematiche>
<br>
<br>

<div class="noMobileNews">
    <div class="newsletter">
        <div class="row">
            <div class="col">
                <h2>Rimani in contatto con noi <br />
                    iscriviti alla nostra newsletter ></h2>
            </div>
            <div class="col">
                <h3>Entra nella community di Zampino Viaggi!</h3>
                <p>Clicca sul pulsante qui sotto, compila il form e riceverai le nostre<br />
                    novità su proposte, esperienze, eventi e qualche curiosità.</p>  
            </div>
        </div>
        <div class="row">
            <a href="#" class="btn btn-primary signinNewsButton">Scopri</a>
        </div>
    </div>
</div>


<div class="mobileNews">
    <div class="newsletter">
        <div class="row">
            <div class="col">
                <h2>Rimani in contatto con noi<br />iscriviti alla nostra newsletter</h2>
            </div>
        </div>
        <br>
        <div class="row">
            <div class="col-sm-12">
                <h3>Entra nella community di Zampino Viaggi!</h3>
                <br>
                <p>Clicca sul pulsante qui sotto, compila il form e riceverai le nostre<br />novità su proposte, esperienze, eventi e qualche curiosità.</p>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <a href="#" class="btn btn-primary signinNewsButton">Scopri</a>
            </div>
        </div>
    </div>
</div>
